const TOKEN_KEY = 'epintong-token';
const USER_KEY = 'epintong-user';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

function parseTokenPayload(token) {
  if (!token || token.split('.').length < 2) {
    return null;
  }
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    return JSON.parse(window.atob(padded));
  } catch (error) {
    return null;
  }
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function isTokenExpired(token = getToken()) {
  if (!token) {
    return true;
  }
  const payload = parseTokenPayload(token);
  if (!payload || !payload.exp) {
    return false;
  }
  return payload.exp * 1000 <= Date.now();
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
}

export function getUser() {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}
